import React from "react";
import { connect } from "react-redux";
import { Card, CardText } from "material-ui/Card";
import { fetchContent } from "../modules/t&c";
import { message } from "../../../store/messageBar";
import { content } from "./content";

class TermsAndConditions extends React.Component {
  state = {
    content: ""
  };

  componentDidMount() {
    this.getContent();
  }

  getContent = () => {
    fetchContent()
      .then(res => this.setState({ content: res.data.body }))
      .catch(error => {
        if (error.response && error.response.data) {
          if (
            error.response &&
            error.response.data &&
            typeof error.response.data.error === "string"
          ) {
            this.props.message(error.response.data.error);
          } else {
            this.props.message(error.response.statusText);
          }
        }
      });
  };

  render() {
    return (
      <Card>
        <h3 className="pt-3 pl-4">Terms and conditions</h3>
        <CardText>
          <div
            dangerouslySetInnerHTML={{
              __html: this.state.content
            }}
          />
          {!this.state.content && content}
        </CardText>
      </Card>
    );
  }
}

export default connect(
  null,
  { message }
)(TermsAndConditions);



// WEBPACK FOOTER //
// ./src/routes/TermsAndConditions/components/TermsAndConditions.js